import { Component, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

interface HexToRGBAResult {
  rgba: string;
  isValid: boolean;
}

@Component({
  selector: 'app-status-badge',
  standalone: true,
  imports: [CommonModule],
  template: `
    <span
      [class]="badgeClasses()"
      [style.color]="colorCode()"
      [style.border-color]="colorCode()"
      [style.background-color]="backgroundColor()"
      [style.border-width]="borderWidth()"
      [style.border-style]="'solid'"
      [style.border-radius]="'9999px'">
      {{ label() }}
    </span>
  `,
  styles: []
})
export class StatusBadgeComponent {
  label = input.required<string>();
  colorCode = input.required<string>();
  className = input<string>('');
  borderWidth = input<string>('1px');

  /**
   * Converts hex color to RGBA format with specified alpha
   */
  private hexToRGBA(hex: string, alpha: number): HexToRGBAResult {
    const cleanHex = hex?.replace('#', '');
    if (!cleanHex || cleanHex.length !== 6) {
      return { rgba: '', isValid: false };
    }

    const match = cleanHex.match(/.{1,2}/g);
    if (!match) {
      return { rgba: '', isValid: false };
    }

    const [r, g, b] = match.map(val => parseInt(val, 16));
    return { rgba: `rgba(${r}, ${g}, ${b}, ${alpha})`, isValid: true };
  }

  /**
   * Computed background color with 0.1 alpha
   */
  backgroundColor = computed(() => {
    const result = this.hexToRGBA(this.colorCode(), 0.1);
    return result.isValid ? result.rgba : '';
  });

  /**
   * Computed badge classes
   */
  badgeClasses = computed(() => {
    const baseClasses = [
      'inline-block',
      'px-3',
      'py-1.5',
      'text-sm',
      'font-medium',
      'whitespace-nowrap'
    ];
    
    const result = this.hexToRGBA(this.colorCode(), 0.1);
    
    if (result.isValid) {
      baseClasses.push('border');
    }

    if (this.className()) {
      baseClasses.push(this.className());
    }

    return baseClasses.join(' ');
  });
}

